import {apiGetWithRetry} from './client';

export function getPlans(product) {
    const qs = product ? `?product=${encodeURIComponent(product)}` : '';
    return apiGetWithRetry(`/celebs/plans${qs}`);
}
